export default __webpack_public_path__ + "static/media/artisanat-certifie.4debec38.png";